<template>
  <div
    class="base-container-input--new"
    :class="[
      horizontalTitle
        ? 'd-flex align-items-center gap-5 justify-content-between'
        : '',
      options.length ? 'position-relative' : '',
    ]"
    :ref="inputRef"
  >
    <div class="base-container-input-title" v-if="nameSign">
      <span
        :class="[disabled ? 'text-disabled' : '', signClass ? signClass : '']"
        class="input-title"
        >{{ nameSign }} <slot name="label"></slot
      ></span>
    </div>
    <input
      class="base-input--new"
      :class="inputClass"
      :style="[inputStyle, { width: `${width}px` }]"
      :type="inputType"
      @input="onInput"
      :placeholder="placeholder"
      @paste="onPaste"
      :value="value"
      :disabled="disabled"
      @focus="openSelect(true)"
      :maxlength="resolvedMaxLength"
      v-click-outside="outsideClickHandler"
      @blur="onInput"
      @keyup.enter="onKeyupEnter"
      @change="onChange"
    />
    <div
      class="base-input-options"
      :class="{
        'base-input-options--show': selectOpened,
      }"
    >
      <div
        class="base-input-options__item"
        v-for="(item, index) in options"
        :key="index"
        @click="
          () => {
            $emit('selectData', {
              name: inputName,
              value: item,
              type: 'select',
              ...additionalParams,
            });
          }
        "
      >
        {{ item?.[selectKey] }}
      </div>
    </div>
  </div>
</template>

<script>
import IMask from "imask";
export default {
  components: {},
  props: {
    selectFocusmethod: {
      type: String,
      default: "focus",
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectKey: {
      type: String,
      default: null,
    },
    inputClass: {
      type: String,
      default: "",
    },
    inputRef: {
      default: "baseInput",
    },
    additionalParams: {
      default: () => {},
    },
    inputName: {
      type: String,
    },
    nameSign: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      default: "",
    },
    width: {
      type: String,
    },
    inputType: {
      type: String,
      default: "text",
    },
    inputStyle: {
      default: () => {},
    },
    disabled: {
      default: false,
    },

    inputMask: {
      default: false,
    },
    horizontalTitle: {
      type: Boolean,
      default: false,
    },
    signClass: {
      type: String,
    },
    maxLength: {
      type: [String, Number],
    },
    forFinanceType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      masked: null,
      selectOpened: false,
    };
  },
  computed: {
    resolvedMaxLength() {
      if (
        this.maxLength === undefined ||
        this.maxLength === null ||
        this.maxLength === ""
      ) {
        return null;
      }

      const parsedMaxLength = Number(this.maxLength);

      if (!Number.isFinite(parsedMaxLength) || parsedMaxLength <= 0) {
        return null;
      }

      return parsedMaxLength;
    },
  },

  methods: {
    outsideClickHandler(e) {
      if (this.options.length) {
        this.selectOpened = false;
      }
    },
    selectData(data) {
      this.$emit("selectData", {
        name: this.inputName,
        value: data,
        type: "select",
        ...this.additionalParams,
      });

      this.selectOpened = false;
    },
    openSelect(state) {
      if (this.selectFocusmethod == "focus") {
        setTimeout(() => {
          this.selectOpened = state;
        }, 1);
      }
    },
    onInput(event) {
      if (this.forFinanceType && this.inputRef != "baseInput") {
        // это костыль для обработки инпутов где требуется запятая вместе точки, в общем там, где финансы
        let value = event.target.value;
        value = value.replace(".", ",");
        value = value.replace(/[^0-9,]/g, "");
        const parts = value.split(",");
        if (parts.length > 2) {
          value = parts[0] + "," + parts.slice(1).join("");
        }
        const inputEl = this.$refs[this.inputRef]?.querySelector("input");
        inputEl.value = value;
        //
        this.$emit("input", {
          name: this.inputName,
          value: event.target.value,
          ...this.additionalParams,
        });
      } else {
        this.$emit("input", {
          name: this.inputName,
          value: this.inputMask ? this.getCurrentValue() : event.target.value,
          ...this.additionalParams,
        });
      }
    },
    onChange(event) {
      this.$emit("change", {
        name: this.inputName,
        value: this.inputMask ? this.getCurrentValue() : event.target.value,
        ...this.additionalParams,
      });
    },
    onKeyupEnter(event) {
      this.$emit("keyupEnter");
    },
    onPaste(event) {
      const isPhoneMask =
        this.inputMask &&
        typeof this.inputMask === "string" &&
        (this.inputMask.includes("+") ||
          this.inputMask.includes("(") ||
          this.inputMask.includes(")") ||
          this.inputMask.includes("-"));
      if (!isPhoneMask) {
        this.onInput(event);
        return;
      }

      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const digitsOnly = pastedText.replace(/\D/g, "");
      const last10Digits = digitsOnly.slice(-10);

      const inputEl = event.target;
      const start = inputEl.selectionStart;
      const end = inputEl.selectionEnd;
      const currentValue = inputEl.value;

      const newRawValue =
        currentValue.substring(0, start) +
        last10Digits +
        currentValue.substring(end);

      if (this.masked) {
        this.masked.value = newRawValue;
      } else {
        inputEl.value = newRawValue;
      }

      const newCursorPos = start + last10Digits.length;
      this.$nextTick(() => {
        inputEl.setSelectionRange(newCursorPos, newCursorPos);
      });

      this.$emit("input", {
        name: this.inputName,
        value: inputEl.value,
        ...this.additionalParams,
      });
    },
    getCurrentValue() {
      if (this.masked) {
        return this.masked.value; // отформатированное с учётом scale, min, max и т.д.
      }
      // fallback, если маски нет (берём из DOM)
      const inputEl = this.$refs[this.inputRef]?.querySelector("input");
      return inputEl ? inputEl.value : "";
    },
  },
  mounted() {
    if (this.selectFocusmethod == "input") {
      this.$refs[this.inputRef].addEventListener("input", () => {
        this.selectOpened = true;
      });
    }
    if (this.inputMask) {
      let element = null;
      let maskOptions = {};
      if (typeof this.inputMask === "string") {
        element = this.$refs[this.inputRef].querySelector("input");
        maskOptions = {
          mask: this.inputMask,
          overwrite: true,
        };
      } else {
        element = this.$refs[this.inputRef].querySelector("input");
        maskOptions = {
          overwrite: true,
          ...this.inputMask,
        };
      }
      this.masked = IMask(element, maskOptions);
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.masked && newVal !== this.masked.value) {
          this.masked.value = newVal ?? "";
        }
      },
      immediate: true,
    },
  },
};
</script>
